import { ranking } from '@/mocks/home';

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">热门排行</h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">本周最受读者欢迎的漫画作品，看看有没有你的心头好</p>
        </div>
        <div className="max-w-3xl mx-auto space-y-3">
          {ranking.map((item) => (
            <a
              key={item.id}
              href="#ranking"
              onClick={(e) => e.preventDefault()}
              className="flex items-center gap-4 p-4 bg-background-50 rounded-xl border border-background-200/50 hover:border-primary-200/60 transition-all cursor-pointer group"
            >
              <div className={`w-10 h-10 flex-shrink-0 rounded-xl flex items-center justify-center font-heading font-bold text-lg ${
                item.rank === 1 ? 'bg-accent-500 text-background-50' :
                item.rank === 2 ? 'bg-primary-400 text-background-50' :
                item.rank === 3 ? 'bg-secondary-500 text-background-50' :
                'bg-background-200 text-foreground-600'
              }`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 flex-wrap mb-1">
                  <h3 className="text-base font-bold text-foreground-900 group-hover:text-primary-500 transition-colors">{item.title}</h3>
                  <span className="text-xs px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 font-medium whitespace-nowrap">{item.type}</span>
                </div>
                <div className="flex items-center gap-2 flex-wrap">
                  {item.tags.map((tag) => (
                    <span key={tag} className="text-xs text-foreground-500 bg-background-200/70 px-1.5 py-0.5 rounded whitespace-nowrap">{tag}</span>
                  ))}
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <div className="flex items-center gap-1 text-accent-500 font-heading font-bold text-base">
                  <span className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-star-fill text-xs"></i>
                  </span>
                  {item.hot}
                </div>
                <div className="text-xs text-foreground-500 whitespace-nowrap">{item.update}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}